export const getAlertConfig = (state) => state.alerts
